import React, {Component} from 'react';
import {Form, Input, Radio, Select} from "antd";
import {DataTableSelect} from "../../../view/sysManagement/selectedTopicManagement/formContent/selectTagInput";
import BaseComponent from "../../../base/BaseComponent";
import {systemBaseEvent} from "../../../base/baseEvent";

const FormItem = Form.Item;

const defaultState = {
    publishType: 0,
    publishId: 0,
    publishName: "",
    publishPhoto: "",
    checkedData:[],
    userParams: {
        roleOption: ["business:appointment:get"]
    },
    permission: 1
};
const {Option} = Select;
class Publisher extends BaseComponent {

    static defaultProps = {...defaultState, colon: true};

    constructor(props) {
        super(props);
        this.state = {...defaultState, ...props, currentMediaId: props.publishId};
        if(this.state.publishId){
            this.state.checkedData = [{key : this.state.publishId, id : this.state.publishId, name : this.state.publishName, photo: this.state.publishPhoto}];
        }
    }

    getData(){
        let {publishType, publishId, publishName, permission, publishPhoto} = this.state;
        return {publishType, publishId, publishName, permission, publishPhoto};
    }

    getMediaColumnSync(currentMediaId, mediaId) {
        this.request({
            url: "/cm-sites-pms/columnSync/getMediaColumnSync",
            body: {currentMediaId, mediaId},
            callBack: (res) => {
                systemBaseEvent.syncExec("publishAccountChange", {res});
            }
        });
    }

    render() {
        let deptId = this.sysConfigGetValueByKey("fist_level_dept", "");
        let isDisabled = false;
        if(!deptId || (deptId && deptId !== window?.currentUser?.defaultInfo?.dept?.id)) {
            isDisabled = true;
        }
        const options = [
            {
                key: "1",
                value: 1,
                title: "公开"
            },
            {
                key: "2",
                value: 2,
                title: "仅内部员工可见"
            },
            {
                key: "3",
                value: 3,
                title: "仅内部管理人员可见"
            },
        ];
        const columns = [
            {
                title: "头像",
                key: "photo",
                dataIndex: "photo",
                render: (text) => {
                    return (
                        <img style={{width: 46, height: 46, objectFit: "cover"}} src={text}/>
                    )
                }
            },
            {
                title: "名称",
                dataIndex: "name",
                key: "name",
                ellipsis: true
            },
            {
                title: "类型",
                dataIndex: "type",
                key: "type",
                ellipsis: true
            },
            {
                title: "所属单位",
                dataIndex: "deptName",
                key: "deptName",
                ellipsis: true
            }
        ];
        return (
            <>
                <FormItem
                    colon={this.props.colon}
                    label={this.props.label || '发布账号'}
                    required={false}
                >
                    <Radio.Group
                        disabled={isDisabled}
                        style={{display: "inline-block"}}
                        onChange={e => this.setState({...defaultState, publishType:e.target.value})}
                        value={this.state.publishType}
                    >
                        <Radio value={0}>机构号</Radio>
                        <Radio value={1}>达人号</Radio>
                    </Radio.Group>
                    <Input readOnly value={this.state.publishName?this.state.publishName:undefined} style={{width:200}} placeholder={"请选择"} onClick={()=>{
                        if(!isDisabled) {
                            this.dataTableSelect.show(this.state.publishId?[{key:this.state.publishId}]:[]);
                        }
                    }} />
                    <DataTableSelect checkedData={this.state.checkedData} checkType={"radio"}
                                     ref={dataTableSelect=>this.dataTableSelect = dataTableSelect}
                                     dataRequest={{
                                         url: "/cm-sites-mmp/rm/rmTypeList",
                                         method: "get",
                                         search: "name",
                                         params: {type: this.state.publishType},
                                         callback: (item) => {
                                             item.key = item.mediaId;
                                         }
                                     }}
                                     columns={columns}
                                     searchPlaceholder={"请输入关键字"}
                                     title={this.state.publishType === 0 ? "请选择机构号" : "请选择达人号"}
                                     onOk={checkedData=>{
                                         let publishId = checkedData[0].mediaId ? checkedData[0].mediaId : this.state.checkedData[0].id;
                                         let publishName = checkedData[0].name ? checkedData[0].name : this.state.checkedData[0].name;
                                         let publishPhoto = checkedData[0].photo ? checkedData[0].photo : this.state.checkedData[0].photo;
                                         let checkedDataArr = (checkedData && checkedData.length) ? checkedData : this.state.checkedData;
                                         this.setState({publishId, publishName, publishPhoto, checkedData: checkedDataArr})
                                         this.getMediaColumnSync(this.state.currentMediaId, checkedData[0].mediaId ? checkedData[0].mediaId : "");
                                     }}  />
                </FormItem>
                <FormItem
                    colon={this.props.colon}
                    label={'可见范围'}
                    required={true}
                >
                    <Select
                        style={{width: 200}}
                        value={this.state.permission}
                        onChange={(value) => {
                            this.setState({permission: value})
                        }}>
                        {options.map(i => {
                            return <Option key={i.key} value={i.value}>{i.title}</Option>
                        })}
                    </Select>
                </FormItem>
            </>
        );
    }

}

export default Publisher;
